import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { ConfirmActionModalComponent } from '@app/trackvision/shared/components/confirm-action-modal/confirm-action-modal.component';
import { Section } from '@app/trackvision/shared/model/section.model';
import { Subject } from '@app/trackvision/shared/model/subject.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentsService } from '@services/documents.service';
import { BehaviorSubject } from 'rxjs';
import { TextEditorModalComponent } from '../text-editor-modal/text-editor-modal.component';

@Component({
    selector: 'app-clauses',
    templateUrl: './clauses.component.html',
    styles: [`
    .text-col {
      max-height: 10rem;
      overflow: auto;
      word-wrap: break-word;
    }
    .text-col::-webkit-scrollbar-track {
      background-color: inherit;
    }
    .text-col::-webkit-scrollbar {
      width: 4px;
      background-color: #f0f2f8;
    }
    .text-col::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bebebe;
    }
  `],
    standalone: false
})
export class ClausesComponent implements OnInit {

  @Input()
  selectMode: boolean = false

  @Input()
  clauses: Section[]

  filteredClauses: Section[]

  @Input()
  subjects: Subject[]
  subjectChilds: Subject[]
  selectedSubject: Subject
  selectedSubjectChild: Subject

  nameFilter: string

  selectedClauses: {[id: number]: boolean} = {}

  @Output()
  selectClauses: EventEmitter<Section[]> = new EventEmitter<Section[]>()

  constructor(
    public documentsService: DocumentsService,
    public modalService: NgbModal
  ) { }

  ngOnInit() {
    if (!this.clauses)
      this.getSections()
    else
      this.filteredClauses = this.clauses

    if (!this.subjects)
      this.documentsService.getSubjects().subscribe(response => { 
        this.subjects = response['result']
        this.selectedSubject = undefined
        this.subjectChilds = undefined
        this.selectedSubjectChild = undefined
      })
  }

  async getSubjectChildren(subject: Subject) {
    this.selectedSubjectChild = undefined
    if (!subject) {
      this.subjectChilds = []
    } else {
      const response = await this.documentsService.getSubjects(String(subject.id)).toPromise()
      this.subjectChilds = response['result']
    }
    this.applyFilters()
  }

  applyFilters() {
    this.filteredClauses = this.clauses.filter(clause => {
      if (this.selectedSubject && !this.subjectChilds.map(s => s.id).includes(clause.subjectid))
        return false

      if (this.selectedSubjectChild && !(clause.subjectid == this.selectedSubjectChild.id))
        return false

      if (this.nameFilter && !clause.name.toLowerCase().includes(this.nameFilter.toLowerCase()))
        return false

      return true
    })
  }

  emitSelectionChange() {
    this.selectClauses.emit(
      this.clauses.filter(clause => 
        Object.keys(this.selectedClauses)
          .filter(key => this.selectedClauses[key])
          .map(key => Number(key))
          .includes(clause.id)
      )
    )
  }

  getSections() {
    this.documentsService.getDocumentSections().subscribe(res => {
      this.clauses = res['result']
      this.applyFilters()
    })
  }

  deleteSection(id: number) {
    const confirmModal = this.modalService.open(ConfirmActionModalComponent, { centered: true })

    confirmModal.componentInstance.message = '¿Está seguro de eliminar la cláusula?'
    confirmModal.result.then(confirmed => {
      if (confirmed)
        this.documentsService.deleteSection(id).subscribe(() => this.getSections())
    })
  }

  openClauseCreator() {
    const textEditorModal = this.modalService.open(TextEditorModalComponent, {size: 'xl'})

    textEditorModal.componentInstance.mode = 'createClause'
    textEditorModal.componentInstance.section = new Section('')

    textEditorModal.result
      .then( (result: {section: Section}) => {
        this.documentsService.createSection(result.section).subscribe()
        this.getSections()
      })
      .catch(() => {})
  }

  editSection(section: Section) {
    const textEditorModal = this.modalService.open(TextEditorModalComponent, {size: 'xl'})

    textEditorModal.componentInstance.mode = 'editClause'
    textEditorModal.componentInstance.section = section

    textEditorModal.result
      .then(() => this.getSections())
      .catch(() => {})
  }
}
